import {LocationsDropdownController} from './locations-dropdown.ctrl.js'

const locationsDropdown = () => {
  return {
    restrict: 'AE',
    replace: true,
    scope: {
      width: '=',
      buttonId: '@',
      selectOnReset: '=?',
      locationsList: '=',
      regionsList: '=',
      onLocationChange: '&',
      placeholder: '=',
    },
    controller: LocationsDropdownController,
    template: require('./locations-dropdown.html'),
  }
}

angular
  .module('app.directives')
  .directive('locationsDropdown', locationsDropdown)



// WEBPACK FOOTER //
// ./scripts/shared/directives/locations/locations-dropdown.directive.ctrl.js